import TextFieldMask from './TextFieldMask';
import { cpfOrCnpjValidate } from '../../../commons/validates';
import { toast } from 'react-toastify';
import { maskDocumentCpfCnpj } from '../../../utils/mask-document-cpf-cnpj';


const CpfCnpjField = ({ name, label, value, onChange, ...other }) => {

  const handleChange = (e) => {
    const formatted = maskDocumentCpfCnpj(e.target.value);
    onChange({
      ...e,
      target: {
        ...e.target,
        value: formatted
      }
    });
  };

  const handleBlur = (e) => {
    const [isValid, message] = cpfOrCnpjValidate(e.target.value);
    if (!isValid) toast.error(message, {
      toastId: 'cpf-cnpj-error'
    })
  };

  return (
    <TextFieldMask
      label={label}
      name={name}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      {...other}
    />
  );
};

export default CpfCnpjField;
